import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enCommon from "./locales/langs/en/common.json";
// import hiCommon from "./locales/langs/hi/common.json";

i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  debug: true,

  interpolation: {
    escapeValue: false,
  },

  resources: {
    en: {
      common: enCommon,
    },
    // hi: {
    //   common: hiCommon,
    // },
  },

  ns: ["common"],
  defaultNS: "common",
});

export default i18n;
